import { addCustomEventToGoogleDataLayer } from 'src/utils/google-analytics'

const SESSION_STORAGE_KEY = 'signup_sso_bw'

const getStorageIds = (): number[] => {
  try {
    const storagedIds = JSON.parse(sessionStorage.getItem(SESSION_STORAGE_KEY) || '[]')

    return storagedIds
  } catch {
    return []
  }
}

const setEventAsSentByUserId = (userId): void => {
  const currentStoragedIds = getStorageIds()

  currentStoragedIds.push(parseInt(userId))
  sessionStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(currentStoragedIds))
}

const isEventAlreadySentByUser = (userId): boolean => {
  const currentStoragedIds = getStorageIds()

  return currentStoragedIds.includes(userId)
}

export const sendToGaWhenUserCompleteTheSignUp = ({ userId }): void => {
  const DEFAULT_VALUE_IFRAME_REFERRER_URL = 'https://sso.hotmart.com/signup'

  const urlParams = new URLSearchParams(window.location.search)
  const systemOrigin = urlParams.get('systemOrigin')
  const isEmbed = urlParams.get('isEmbed')
  const iframeOrigin = urlParams.get('url')
  const referrer = urlParams.get('referrer')

  const eventSignUpComplete = {
    event: 'custom_event',
    custom_event_name: 'signup_sso_bw',
    user_id: userId,
    is_embed: isEmbed ?? false,
    iframe_origin_url: iframeOrigin ?? DEFAULT_VALUE_IFRAME_REFERRER_URL,
    iframe_referrer_url: referrer ?? window.location.href,
    system_origin_flag: false,
    system_origin_value: ''
  }

  if (systemOrigin) {
    Object.assign(eventSignUpComplete, {
      system_origin_flag: true,
      system_origin_value: systemOrigin
    })
  }
  if (!isEventAlreadySentByUser(userId)) {
    addCustomEventToGoogleDataLayer(eventSignUpComplete)
    setEventAsSentByUserId(userId)
  }
}
